
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';

export default {
  name: 'ListingBookViewingCard',
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    classes() {
      return new StyleClassNamesBuilder('listing-book-viewing-card')
        .addConditionClassName('active', this.isActive)
        .addClassName(this.className)
        .build();
    },
  },
};
